import { useState, useEffect } from 'react';
import styles from './styles.module.css'
/*
Page to gather clients info & email drawing + info to Empire
*/

// Single source of truth for the default title — prevents reset mismatches
const DEFAULT_TITLE = "Enter Info & We'll Email Estimate";

const InfoPage = ({ passAddress, passImage}) => 
{
  
  //Used for button animation
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);

  // React-controlled title/subtitle state (replaces direct DOM manipulation)
  const [pageTitle, setPageTitle] = useState(DEFAULT_TITLE);
  const [showSubTitle, setShowSubTitle] = useState(false);
  const [showForm, setShowForm] = useState(true);

  //Holds Client Info
  const [formData, setFormData] = 
  useState({
    firstName: '',
    lastName: '',
    phoneNumber: '',
    email: '',
    address: passAddress
  });

  // FIX 4: Re-sync address if passAddress arrives late (async prop) after initial mount
  useEffect(() => {
    if (passAddress) {
      setFormData(prev => ({ ...prev, address: passAddress }));
    }
  }, [passAddress]);

  //Handles Form Changes
  const handleChange = (e) => 
  {
    const { name, value } = e.target;

    if (name === 'phoneNumber') {
      // Strip all non-digits
      const digits = value.replace(/\D/g, '').slice(0, 10);
      // Format as 111-222-3333
      let formatted = digits;
      if (digits.length >= 7) {
        formatted = `${digits.slice(0,3)}-${digits.slice(3,6)}-${digits.slice(6)}`;
      } else if (digits.length >= 4) {
        formatted = `${digits.slice(0,3)}-${digits.slice(3)}`;
      }
      setFormData({ ...formData, phoneNumber: formatted });
      return;
    }

    setFormData({ ...formData, [name]: value });
  };

  // Basic email format validation
  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  //Handles Form Submit
  const handleSubmit = (e) => 
  {
    e.preventDefault();

    // FIX 2: Guard against double-submission while loading
    if (isLoading) return;

    // FIX 3: Remove type="email" from input and rely solely on this regex check
    if (!isValidEmail(formData.email)) {
      setIsError(true);
      setPageTitle("Please enter a valid email address");
      setTimeout(() => {
        setIsError(false);
        setPageTitle(DEFAULT_TITLE);
      }, 2500);
      return;
    }

    setIsLoading(true);
    sendEmail();
  };

  // Function to submit via Brevo - calls Vercel API route
  const sendEmail = () => 
  {
    // FIX 1: Safely extract base64 data — guard against missing comma (blob URLs, corrupted data, etc.)
    let imageData = null;
    if (passImage && typeof passImage === 'string' && passImage.includes(',')) {
      const split = passImage.split(',')[1];
      imageData = split !== undefined ? split : null;
    }

    // Debug log — remove once image issue is confirmed resolved
    console.log('[sendEmail] passImage prefix:', passImage?.substring(0, 60));
    console.log('[sendEmail] imageData (first 30 chars):', imageData?.substring(0, 30) ?? 'null');

    const payload = {
      email:   formData.email,
      name:    formData.firstName + ' ' + formData.lastName,
      phone:   formData.phoneNumber,
      address: formData.address,
      image:   imageData,
    };

    fetch('/api/sendEmail', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(async (res) => {
        const message = await res.text();
        setIsLoading(false);
        if (res.ok && message.trim() === 'OK') {
          setIsSuccess(true);
          setTimeout(() => {
            setPageTitle("Thank You for Submitting! We'll email you within 48 hours");
            setShowSubTitle(true);
            setShowForm(false);
          }, 1000);
        } else {
          setIsSuccess(false);
          setIsError(true);
          console.log("error-message: " + message);
          setPageTitle("Error — please try again");
          setShowSubTitle(false);
          setShowForm(true);
          setTimeout(() => {
            setIsError(false);
            setPageTitle(DEFAULT_TITLE);
          }, 2500);
        }
      })
      .catch(error => {
        setIsSuccess(false);
        setIsLoading(false);
        setIsError(true);
        setPageTitle("Error — please try again");
        setShowSubTitle(false);
        setShowForm(true);
        console.error('Error Submitting:', error);
        setTimeout(() => {
          setIsError(false);
          setPageTitle(DEFAULT_TITLE);
        }, 2500);
      });
  };

  return (
    <div style={{height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <div style={{textAlign: "center", height: '100vh' }}>
        <img style={{ padding: "0px 0px 20px 0px", maxWidth: "350px", width: "100%", marginTop: '40px'}} src="https://empirefences.com/wp-content/uploads/2026/05/ef-logo-2.png" alt="Company Logo" />
        <div style={{ textAlign: "center", color: "#fff" }}>
          <h2 id="pageTitle" style={{color: "black", marginTop: '5%', marginBottom: '10%'}}>{pageTitle}</h2>
        </div>
        {showForm && (
          <form id="infoForm" onSubmit={handleSubmit} style={{ textAlign: 'center'}}>
            <input type="text" name="firstName" style={{width: '250px', height: '35px', fontSize: '16px', textAlign: 'center', borderRadius: '10px'}} value={formData.firstName} onChange={handleChange} placeholder="First Name" required />
            <br></br> <br></br>
            <input type="text" name="lastName" style={{width: '250px', height: '35px', fontSize: '16px', textAlign: 'center', borderRadius: '10px'}} value={formData.lastName} onChange={handleChange} placeholder="Last Name" required />
            <br></br> <br></br>
            <input type="tel" name="phoneNumber" style={{width: '250px', height: '35px', fontSize: '16px', textAlign: 'center', borderRadius: '10px'}} value={formData.phoneNumber} onChange={handleChange} placeholder="Phone Number" required />
            <br></br> <br></br>
            <input type="text" name="email" style={{width: '250px', height: '35px', fontSize: '16px', textAlign: 'center', borderRadius: '10px'}} value={formData.email} onChange={handleChange} placeholder="Email" required />
            <br></br> <br></br>
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '5%'}}>
              <button
                  id="submitB"
                  className={`${styles.button} ${isLoading ? styles.loader : ''} ${isSuccess ? styles.success : ''} ${isError ? styles.error : ''}`}
                  >
                  {isLoading ? '' : isSuccess ? 'Success' : isError ? 'Error' : 'Submit'}
              </button>
            </div>
          </form>
        )}
        {showSubTitle && (
          <h2 id="subTitle" style={{color: "white", textAlign: 'center'}}>An Empire Representative will <br></br> get back to you shortly!</h2>
        )}
      </div>
    </div>
  
  );
}

export default InfoPage;